import { sendToMixpanel } from '..';
import type { FaaLandingPageModule } from './modules';

const trackLandingPageModuleClick = (module: FaaLandingPageModule): void => {
  sendToMixpanel('Click FAA Landing Page Module', {
    siteSection: 'Agents',
    module,
  });
};

export default trackLandingPageModuleClick;
